import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import AssetComponent from "components/core/asset/asset-component";
const MONDAY_LOADER_IMAGE = {
    src: "/static/img/loader/monday_loader.gif"
};
class MondayLoaderComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: "loader-wrapper",
            children: /*#__PURE__*/ _jsx(AssetComponent, {
                image: MONDAY_LOADER_IMAGE
            })
        });
    }
    constructor(props){
        super(props);
    }
}
export { MondayLoaderComponent as default };
